// Copyright (c) 2020 Deere & Company

import {combineReducers} from 'redux';
import {getCombinedReducers as getCombinedSpaDetailsReducers} from './spa-details/reducers';
import {getCombinedReducers as getCombinedWipReducers} from './wip/reducers';

export const getCombinedReducers = () => combineReducers({
    spaDetails: getCombinedSpaDetailsReducers(),
    wip: getCombinedWipReducers()
});



// WEBPACK FOOTER //
// ./src/tabm/tabm-reducers.js